<div style="height: 100%; width: 100%;">
  @if (loading) {
    <bracelit-preloader [absoluteCentered]="true">
    </bracelit-preloader>
  }
  @if (!loading) {
    <div style="display: flex; flex-direction: column; display: flex; align-items: center; justify-content: center; height: 100%; width: 100%;">
            @if (users.length === 0) {
              <ng-template>
                <h2 class="transaction-container primary-border-100" style="width: 100%; display: flex; flex-direction: row; display: flex; align-items: center; justify-content: center;">{{ 'showContacts.haveNo' | translate }}</h2>
              </ng-template>
            }
            @for (user of users; track user.email) {
              <details style="width: 100%;">
                <summary style="font-size: 16px; font-weight: bold; padding: 10px 0;">{{user.name}} {{user.surname}}</summary>
                <div>
                  {{ 'showContacts.name' | translate }}: {{user.name}}
                </div>

                <div>
                  {{ 'showContacts.surname' | translate }}: {{user.surname}}
                </div>

                <div>
                  {{ 'showContacts.email' | translate }}: {{user.email}}
                </div>

                <div>
                  {{ 'showContacts.phone' | translate }}: <a href="tel:{{user.phone}}">{{user.phone}}</a>
                </div>

                <div>
                  {{ 'showContacts.comments' | translate }}: {{user.comment}}
                </div>
              </details>
            }


            <div class="tab-button" style="width: 100%; display: flex; flex-direction: row; display: flex; align-items: center; justify-content: center; margin: 20px 0">
            <button class="primary-background regular-16px-center-white"
                    mat-raised-button
                    [class.disabled-button]="users.length === 0"
                    [disabled]="users.length === 0"
                    type="button"
                    (click)="onDownloadCSV()">
                    {{ 'showContacts.download' | translate }} CSV
            </button>
          </div>
    </div>
  }
</div>
